import {
  UPDATE_USER_PASSWORD,
  USER_PASSWORD_ERROR,
  LOADING_USER_PASSWORD,
} from '../types/PasswordTypes';

import { updatePassword } from '../../services/PasswordService';
import { successMessage, errorMessage } from './FlashActions';
import encryptPassword from '../../helpers/PasswordHelper';

export const userPasswordLoading = () => {
  return { type: LOADING_USER_PASSWORD };
};

export const userPasswordError = () => {
  return { type: USER_PASSWORD_ERROR };
};

export const userPasswordSuccess = () => {
  return { type: UPDATE_USER_PASSWORD };
};

export const updateUserPassword = ({
  newPassword,
  newConfirmationPassword,
  oldPassword,
}) => {
  return async (dispatch) => {
    try {
      dispatch(userPasswordLoading());
      const payload = encryptPassword({
        newPassword,
        newConfirmationPassword,
        oldPassword,
      });

      const res = await updatePassword(payload);
      if (res.status === 200) {
        dispatch(
          successMessage('La contraseña se ha actualizado correctamente'),
        );
        dispatch(userPasswordSuccess());
      } else {
        dispatch(userPasswordError());
        if (res.data?.id === 'AUTH_09') {
          dispatch(errorMessage('El nuevo password debe ser distinto antiguo'));
        } else {
          dispatch(
            errorMessage('Hubo un problema al actualizar la contraseña'),
          );
        }
      }
    } catch (error) {
      dispatch(userPasswordError());
      dispatch(errorMessage('Hubo un problema al actualizar la contraseña'));
    }
  };
};
